// extracted by mini-css-extract-plugin
export default {"CopyRoadmap":"CopyRoadmap_CopyRoadmap__dEwJI","Form":"CopyRoadmap_Form__1MmOo","FlexRow":"CopyRoadmap_FlexRow__QaTit","Username":"CopyRoadmap_Username__R5vc2"};